import { useContext } from 'react';
import { FieldArrayWithId, useFormContext } from 'react-hook-form';

import { AggPageFormContext } from '../../../../context/page-form-context';
import { TPageForm } from '../../page-form/page-form';
import { ProductsPostsForm } from './components/product-posts-form';

type Props = {
  currentProductId: string;
  fields: FieldArrayWithId<TPageForm, 'productAssets'>[]
};

const ProductsPosts = ({ currentProductId, fields }: Props) => {
  const { control } = useFormContext<TPageForm>();
  const { products } = useContext(AggPageFormContext);

  if (products?.length === 0) {
    return null;
  }

  return (
    <div className="w-100 h-100">
      {fields.map((field, productIdx) => {
        if (field?.product_id !== currentProductId) {
          return null;
        }

        return (
          <ProductsPostsForm
            key={field.id}
            control={control}
            currentProductId={currentProductId}
            productIdx={productIdx}
          />
        );
      })}
    </div>
  );
};

export { ProductsPosts };
